//export const BASE_URL = "http://localhost:3000/";
export const BASE_URL = "http://vps54825.publiccloud.com.br:3000/";

//ENDEREÇOS DOS CLIENTES
export const LIST_CLIENTE = BASE_URL + "api/cliente/listar";
export const ADD_CLIENTE = BASE_URL + "api/cliente";
export const UPDATE_CLIENTE = BASE_URL + "api/cliente/";
export const DEL_CLIENTE = BASE_URL + "api/cliente/";
export const UP_LOGO = BASE_URL + "api/file/uploadFile/logomarca/";
export const DOWN_LOGO = BASE_URL + "api/file/downloadFile/logomarca/";

//ENDEREÇOS DOS FORNECEDORES
export const LIST_FORNECEDOR = BASE_URL + "api/fornecedor/listar";
export const ADD_FORNECEDOR = BASE_URL + "api/fornecedor";
export const UPDATE_FORNECEDOR = BASE_URL + "api/fornecedor/";
export const DEL_FORNECEDOR = BASE_URL + "api/fornecedor/";

//ENDEREÇOS DOS EQUIPAMENTOS
export const LIST_EQUIPAMENTO = BASE_URL + "api/equipamento/listar";
export const ADD_EQUIPAMENTO = BASE_URL + "api/equipamento";
export const UPDATE_EQUIPAMENTO = BASE_URL + "api/equipamento/";
export const DEL_EQUIPAMENTO = BASE_URL + "api/equipamento/";
export const UP_EQP_IMG = BASE_URL + "api/file/uploadFile/equipamento/";
export const DOWN_EQP_IMG = BASE_URL + "api/file/downloadFile/equipamento/";

//ENDEREÇOS DOS SERVICOS
export const LIST_SERVICO = BASE_URL + "api/servico/listar/";
export const ADD_SERVICO = BASE_URL + "api/servico";
export const UPDATE_SERVICO = BASE_URL + "api/servico/";
export const DEL_SERVICO = BASE_URL + "api/servico/";

//ENDEREÇOS DAS IMAGENS
export const LIST_IMAGEM = BASE_URL + "api/imagem/listar";
export const ADD_IMAGEM = BASE_URL + "api/imagem";
export const UPDATE_IMAGEM = BASE_URL + "api/imagem/";
export const DEL_IMAGEM = BASE_URL + "api/imagem/";
export const UP_IMAGEM = BASE_URL + "api/file/uploadFile/imagem/";
export const DOWN_IMAGEM = BASE_URL + "api/file/downloadFile/imagem/";

//ENDEREÇOS DAS ATIVIDADE
export const LIST_ATIVIDADE = BASE_URL + "api/atividade/listar";
export const ADD_ATIVIDADE = BASE_URL + "api/atividade";
export const UPDATE_ATIVIDADE = BASE_URL + "api/atividade/";
export const DEL_ATIVIDADE = BASE_URL + "api/atividade/";

//ENDEREÇOS DAS TRABALHO
export const LIST_TRABALHO = BASE_URL + "api/trabalho/listar/";
export const ADD_TRABALHO = BASE_URL + "api/trabalho";
export const UPDATE_TRABALHO = BASE_URL + "api/trabalho/";
export const DEL_TRABALHO = BASE_URL + "api/trabalho/";

//ENDEREÇOS DAS AVULSO
export const LIST_AVULSO = BASE_URL + "api/avulso/listar";
export const ADD_AVULSO = BASE_URL + "api/avulso";
export const UPDATE_AVULSO = BASE_URL + "api/avulso/";
export const DEL_AVULSO = BASE_URL + "api/avulso/";

//ENDEREÇOS DAS EQUIPES
export const LIST_EQUIPE = BASE_URL + "api/equipe/listar";
export const ADD_EQUIPE = BASE_URL + "api/equipe";
export const UPDATE_EQUIPE = BASE_URL + "api/equipe/";
export const DEL_EQUIPE = BASE_URL + "api/equipe/";

export const LIST_DIARIO = BASE_URL + "api/diario/listar/";
export const ADD_DIARIO = BASE_URL + "api/diario";
export const UPDATE_DIARIO = BASE_URL + "api/diario/";
export const DEL_DIARIO = BASE_URL + "api/diario/";

export const LIST_DESPESA = BASE_URL + "api/despesa/listar/";
export const ADD_DESPESA = BASE_URL + "api/despesa";
export const UPDATE_DESPESA = BASE_URL + "api/despesa/";
export const DEL_DESPESA = BASE_URL + "api/despesa/";

//ENDEREÇOS DOS FINANCEIRO
export const LIST_PRODUTO = BASE_URL + "api/produto/listar";
export const ADD_PRODUTO = BASE_URL + "api/produto";
export const UPDATE_PRODUTO = BASE_URL + "api/produto/";
export const DEL_PRODUTO = BASE_URL + "api/produto/";
export const UP_PRODUTO_FIG = BASE_URL + "api/file/uploadFile/produto/";
export const DW_PRODUTO_FIG = BASE_URL + "api/file/downloadFile/produto/";

export const LIST_ORCAMENTO = BASE_URL + "api/orcamento/listar";
export const ADD_ORCAMENTO = BASE_URL + "api/orcamento";
export const UPDATE_ORCAMENTO = BASE_URL + "api/orcamento/";
export const DEL_ORCAMENTO = BASE_URL + "api/orcamento/";
export const LIST_ITEM_ORCAMENTO = BASE_URL + "api/orcamento/item/listar/";
export const ADD_ITEM_ORCAMENTO = BASE_URL + "api/orcamento/item/";
export const UPDATE_ITEM_ORCAMENTO = BASE_URL + "api/orcamento/item/";
export const DEL_ITEM_ORCAMENTO = BASE_URL + "api/orcamento/item/";

export const LIST_FATURAMENTO = BASE_URL + "api/faturamento/listar";
export const ADD_FATURAMENTO = BASE_URL + "api/faturamento";
export const UPDATE_FATURAMENTO = BASE_URL + "api/faturamento/";
export const DEL_FATURAMENTO = BASE_URL + "api/faturamento/";

//ENDEREÇOS DOS INSPECAO
export const LIST_CONSUMIVEL = BASE_URL + "api/consumivel/listar";
export const ADD_CONSUMIVEL = BASE_URL + "api/consumivel";
export const UPDATE_CONSUMIVEL = BASE_URL + "api/consumivel/";
export const DEL_CONSUMIVEL = BASE_URL + "api/consumivel/";

export const LIST_INSTRUMENTO = BASE_URL + "api/instrumento/listar";
export const ADD_INSTRUMENTO = BASE_URL + "api/instrumento";
export const UPDATE_INSTRUMENTO = BASE_URL + "api/instrumento/";
export const DEL_INSTRUMENTO = BASE_URL + "api/instrumento/";

export const LIST_PROFISSIONAL = BASE_URL + "api/profissional/listar";
export const ADD_PROFISSIONAL = BASE_URL + "api/profissional";
export const UPDATE_PROFISSIONAL = BASE_URL + "api/profissional/";
export const DEL_PROFISSIONAL = BASE_URL + "api/profissional/";
export const UP_STAMP = BASE_URL + "api/file/uploadFile/profissional/";
export const DOWN_STAMP = BASE_URL + "api/file/downloadFile/profissional/";

export const LIST_DOCUMENTO = BASE_URL + "api/documento/listar";
export const ADD_DOCUMENTO = BASE_URL + "api/documento";
export const UPDATE_DOCUMENTO = BASE_URL + "api/documento/";
export const DEL_DOCUMENTO = BASE_URL + "api/documento/";

//ENDEREÇOS DO ARMAZEM
export const LIST_ARMAZEM = BASE_URL + "api/armazem/listar";
export const ADD_ARMAZEM = BASE_URL + "api/armazem";
export const UPDATE_ARMAZEM = BASE_URL + "api/armazem/";
export const DEL_ARMAZEM = BASE_URL + "api/armazem/";

export const LIST_PRIORIDADE = BASE_URL + "api/prioridade/listar";
export const ADD_PRIORIDADE = BASE_URL + "api/prioridade";
export const UPDATE_PRIORIDADE = BASE_URL + "api/prioridade/";
export const DEL_PRIORIDADE = BASE_URL + "api/prioridade/";
export const LIST_ITEM_PRIORIDADE = BASE_URL + "api/prioridade/item/listar/";
export const ADD_ITEM_PRIORIDADE = BASE_URL + "api/prioridade/item";
export const UPDATE_ITEM_PRIORIDADE = BASE_URL + "api/prioridade/item/";
export const DEL_ITEM_PRIORIDADE = BASE_URL + "api/prioridade/item/";

export const LIST_ENTRADA = BASE_URL + "api/entrada/listar";
export const ADD_ENTRADA = BASE_URL + "api/entrada";
export const UPDATE_ENTRADA = BASE_URL + "api/entrada/";
export const DEL_ENTRADA = BASE_URL + "api/entrada/";
export const LIST_ITEM_ENTRADA = BASE_URL + "api/entrada/item/listar/";
export const ADD_ITEM_ENTRADA = BASE_URL + "api/entrada/item";
export const UPDATE_ITEM_ENTRADA = BASE_URL + "api/entrada/item/";
export const DEL_ITEM_ENTRADA = BASE_URL + "api/entrada/item/";

export const LIST_SAIDA = BASE_URL + "api/saida/listar";
export const ADD_SAIDA = BASE_URL + "api/saida";
export const UPDATE_SAIDA = BASE_URL + "api/saida/";
export const DEL_SAIDA = BASE_URL + "api/saida/";
export const LIST_ITEM_SAIDA = BASE_URL + "api/saida/item/listar/";
export const ADD_ITEM_SAIDA = BASE_URL + "api/saida/item";
export const UPDATE_ITEM_SAIDA = BASE_URL + "api/saida/item/";
export const DEL_ITEM_SAIDA = BASE_URL + "api/saida/item/";
export const UP_PROTOCOLO = BASE_URL + "api/file/uploadFile/protocolo/";
export const DOWN_PROTOCOLO = BASE_URL + "api/file/downloadFile/protocolo/";

//ENDEREÇOS DOS VEICULOS
export const LIST_VEICULO = BASE_URL + "api/veiculo/listar";
export const ADD_VEICULO = BASE_URL + "api/veiculo";
export const UPDATE_VEICULO = BASE_URL + "api/veiculo/";
export const DEL_VEICULO = BASE_URL + "api/veiculo/";
export const UP_CRLV = BASE_URL + "api/file/uploadFile/crlv/";
export const DOWN_CRLV = BASE_URL + "api/file/downloadFile/crlv/";

export const LIST_ABASTECIMENTO = BASE_URL + "api/abastecimento/listar/";
export const ADD_ABASTECIMENTO = BASE_URL + "api/abastecimento";
export const UPDATE_ABASTECIMENTO = BASE_URL + "api/abastecimento/";
export const DEL_ABASTECIMENTO = BASE_URL + "api/abastecimento/";

export const LIST_MANUTENCAO = BASE_URL + "api/manutencao/listar/";
export const ADD_MANUTENCAO = BASE_URL + "api/manutencao";
export const UPDATE_MANUTENCAO = BASE_URL + "api/manutencao/";
export const DEL_MANUTENCAO = BASE_URL + "api/manutencao/";

//ENDEREÇOS DOS TEMPLATES PARA RELATÓRIOS
export const CERTIFICADO_TEMP = BASE_URL + "api/template/certificado/listar";
export const ITEM_CERTIFICADO_TEMP = BASE_URL + "api/template/certificado/item/listar/";
export const INSPECAO_TEMP = BASE_URL + "api/template/inspecao/listar";
export const ITEM_INSPECAO_TEMP = BASE_URL + "api/template/inspecao/item/listar/";
//--------------------------------------------------------------------------------------------------
export const MEDICOES_TEMP = BASE_URL + "api/template/medicao/listar";
export const ITEM_MEDICOES_TEMP = BASE_URL + "api/template/medicao/item/listar/";
export const UPDATE_MEDICOES = BASE_URL + "api/template/medicao/";
export const UPDATE_ITEM_MEDICOES = BASE_URL + "api/template/medicao/item/";
//--------------------------------------------------------------------------------------------------
export const CHECKLIST_TEMP = BASE_URL + "api/template/checklist/listar";
export const ITEM_CHECKLIST_TEMP = BASE_URL + "api/template/checklist/item/listar/";
export const UPDATE_CHECKLIST = BASE_URL + "api/template/checklist/";
export const UPDATE_ITEM_CHECKLIST = BASE_URL + "api/template/checklist/item/";
//--------------------------------------------------------------------------------------------------
export const PLANO_TEMP = BASE_URL + "api/template/plano/listar";
export const ITEM_PLANO_TEMP = BASE_URL + "api/template/plano/item/listar/";
export const UPDATE_PLANO = BASE_URL + "api/template/plano/";
export const UPDATE_ITEM_PLANO = BASE_URL + "api/template/plano/item/";
//--------------------------------------------------------------------------------------------------
export const LAUDO_TEMP = BASE_URL + "api/template/laudo/listar";
export const COMPONENTE_LAUDO_TEMP = BASE_URL + "api/template/laudo/componentes/listar/";
export const NORMA_LAUDO_TEMP = BASE_URL + "api/template/laudo/normas/listar/";
export const CONDICAO_LAUDO_TEMP = BASE_URL + "api/template/laudo/condicoes/listar/";
export const RISCO_LAUDO_TEMP = BASE_URL + "api/template/laudo/riscos/listar/";
export const MECANICO_LAUDO_TEMP = BASE_URL + "api/template/laudo/mecanicos/listar/";
export const ELETRICO_LAUDO_TEMP = BASE_URL + "api/template/laudo/eletricos/listar/";
export const MOTOR_LAUDO_TEMP = BASE_URL + "api/template/laudo/motores/listar/";
export const RECOMENDACAO_LAUDO_TEMP = BASE_URL + "api/template/laudo/recomendacoes/listar/";

